export enum PaymentNotificationTypeValues {
    None = 0,
    Broker = 1,
    Client = 2,
    BrokerAndClient = Broker | Client
}